// Function to get user info from localStorage
export const getUserInfo = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

// Function to set user info in localStorage
export const setUserInfo = (user) => {
  localStorage.setItem('user', JSON.stringify(user));
};